import React, { Component } from 'react';
import { get } from 'lodash';
import {
  Checkbox,
  // Toggle,
  ListItem,
  FlatButton,
  // RaisedButton,
} from 'material-ui';
import FrozenIcon from 'material-ui/svg-icons/places/ac-unit';


import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';

import { getTranslationByLocale } from '../../../utils/TranslationUtils';
import { formatPrice } from '../../../utils/NumberUtils';
// import ProductStats from '../../ProductStats';

const styles = {
  inputWrapper: {
    display: 'flex',
    height: '60px',
    alignItems: 'center',
  },
  subtitle: {
    fontSize: '12px',
    paddingLeft: '16px',
  },
  lockedPrice: { marginLeft: '0.5em', width: 'auto' },
  labelStyle: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'inline-flex',
  },
  checkboxDiv: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  priceBtn: {
    paddingLeft: '0',
  },
};

const getMarket = (markets, countryCode) => (
  markets.find((market) => (
    market.countryCode === countryCode
  ))
);

export class CheckboxAndInput extends Component {
  shouldComponentUpdate = (nextProps) => {
    if (this.props.openProduct || nextProps.openProduct) {
      return false;
    }
    return true;
  }

  handleCheck = (event, isChecked, choice) => {
    const { input: { value, onChange } } = this.props;
    if (isChecked) {
      onChange([...value, ...[{ product: choice.code }]]);
    } else {
      onChange(value.filter((v) => v.product !== event.target.value));
    }
  };

  handlePriceChanged = (e, product) => {
    const { input: { value, onChange } } = this.props;
    const val = value.find((v) => v.product === product);
    if (val) {
      val.price = parseInt(e.target.value, 10);
      onChange(value);
    }
  };

  handleLockedPriceToggle = (checked, product) => {
    const { input: { value, onChange } } = this.props;
    const val = value.find((v) => v.product === product);
    if (val) {
      val.lockedPrice = checked;
      onChange(value);
    }
  };

  price = () => {
    const { choiceValue } = this.props;
    if (choiceValue) {
      return choiceValue.price;
    }
    return 0;
  };

  render() {
    const {
      choice,
      choiceValue,
      input: { value },
      options,
      marketValue,
      translate, // eslint-disable-line
      permissions,
      locale,
      // isLoadingBigdata,
    } = this.props;

    const choiceName = get(choice, 'internalName');
    const markets = get(choice, 'markets');
    const code = get(choice, 'code');
    const cashierProduct = get(choice, 'private'); // means basically "cashier only" product
    const unlockedBy = get(choice, 'unlockedBy'); // means basically "cashier only" product
    const precision = marketValue.currencyPrecision;
    const currency = marketValue.currencyCode;
    const market = markets && markets.find((mkt) => marketValue && mkt.countryCode === marketValue.countryCode);
    const productIsSelected = choiceValue !== undefined;
    // const costPerPortion = get(choice, 'costPerPortion');
    let marketSuggestedPrice = marketValue ? getMarket(choice.markets, marketValue.countryCode) : null;
    marketSuggestedPrice = marketSuggestedPrice && marketSuggestedPrice.suggestedPrice ? marketSuggestedPrice.suggestedPrice : 0;

    if (marketSuggestedPrice === 0 && !unlockedBy && !cashierProduct && !choiceValue) {
      return null;
    }
    const productTitle = getTranslationByLocale(get(choice, 'title'), locale);
    // const productSubtitle = getTranslationByLocale(get(choice, 'subtitle'), locale);
    // const formattedCost = costPerPortion ? parseFloat(costPerPortion.replace(/,/gi, '.')) * 100 : undefined;
    // const formattedPrice = formatPrice(marketSuggestedPrice - formattedCost, precision);
    // const formattedSales = this.props.bigdata ? (this.props.bigdata.salesPerGuest * 100).toFixed(2) : undefined;
    // const formattedVenues = this.props.bigdata ? this.props.bigdata.venues.length : undefined;

    return (
      <ListItem key={code} hoverColor="rbga(0,0,0,0)" innerDivStyle={{ padding: '16px 0 0 16px' }}>
        <div style={styles.inputWrapper}>
          <div style={styles.checkboxDiv}>
            <Checkbox
              key={`${choice._id}-checkbox`}
              disabled={(market && market.locked && !permissions.superUser) || (choiceValue && !!choiceValue.event && choiceValue.event.active)}
              checked={productIsSelected}
              onCheck={(e, checked) => this.handleCheck(e, checked, choice)}
              value={code}
              style={{ width: '10%' }}
              {...options}
            />
            <a style={styles.link} target="_blank" rel="noopener noreferrer" href={`#/products/${code}/show`}>
              <div style={choice.frozen ? { ...styles.labelStyle, color: '#2fb2ff' } : { ...styles.labelStyle }}>
                {choiceName}
                {choice.frozen && (
                  <FrozenIcon style={{ fill: '#2fb2ff', height: '14px', width: '14px' }} />
                )}
                {!unlockedBy && !cashierProduct && marketSuggestedPrice === 0 && (
                  <small> ({translate('onlyDeactivateMsg')})</small>
                )}
              </div>
            </a>
          </div>
          {/* <a target="_blank" rel="noopener noreferrer" href={`#/products/${code}/show`}>
            <RaisedButton label=">" />
          </a> */}
        </div>
        <div style={styles.subtitle}>
          {productTitle && <div>{productTitle}</div>}
          {/* <div>{productSubtitle}</div> */}
        </div>

        {marketValue && value ?
          <div>
            <FlatButton
              primary={choiceValue && choiceValue.price}
              style={styles.priceBtn}
              label={
                (choiceValue && choiceValue.price !== null && choiceValue.price !== undefined) || marketSuggestedPrice ? (
                  formatPrice(choiceValue && choiceValue.price !== null && choiceValue.price !== undefined ? choiceValue.price : marketSuggestedPrice, precision, currency)
                ) : translate('noPriceSetMsg')
              }
              onClick={() => (
                this.props.selectProduct(
                  choiceValue,
                  market.minPrice,
                  market.maxPrice,
                  precision,
                  currency,
                )
              )}
              disabled={!choiceValue || !permissions.priceEditor || (market && !market.minPrice) || (market && !market.maxPrice)}
            />
            {(choiceValue && choiceValue.price !== null) ? (
              <FlatButton
                label={translate('reset')}
                onClick={() => this.handlePriceChanged({ target: { value: `${marketSuggestedPrice}` } }, code)}
              />
            ) : null}
            <small style={{ width: '100%', color: 'rgb(183, 28, 28)' }}>
              {market && market.minPrice && market.minPrice && (
                <span>
                  {`Min. ${formatPrice(market.minPrice || marketSuggestedPrice, precision, currency)}`}&nbsp;
                  {`Max. ${formatPrice(market.maxPrice || marketSuggestedPrice, precision, currency)}`}
                </span>
              )}
              <div>
                {market && market.maxPrice && !market.minPrice && (
                  translate('missingMin')
                )}
                {market && market.minPrice && !market.maxPrice && (
                  translate('missingMax')
                )}
                {(!market || (!market.minPrice && !market.maxPrice)) && (
                  translate('missingMinAndMax')
                )}
              </div>
            </small>
          </div>
          : null
        }
        {/* <a style={styles.link} target="_blank" rel="noopener noreferrer" href={`#/statistics/${code}`}>
          <ProductStats
            style={{ paddingLeft: '13px' }}
            sales={formattedSales}
            margin={formattedPrice}
            currency={currency}
            venues={formattedVenues}
            isLoading={isLoadingBigdata}
          />
        </a> */}
      </ListItem>
    );
  }
}

export default connect(
  (state) => state,
  {
    push: pushAction,
  },
)(CheckboxAndInput);
